module.exports = __webpack_public_path__ + "static/needsbackground-1420dd321b65a0be8d39df9a8f387f5e.png";